module.exports = __webpack_public_path__ + "img/fog.cd7aa81f.png";